import { render, staticRenderFns } from "./MyPaper.vue?vue&type=template&id=48577fba"
import script from "./MyPaper.vue?vue&type=script&lang=js"
export * from "./MyPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports